import { render, staticRenderFns } from "./DialogStudentRating.vue?vue&type=template&id=51d3f4be&scoped=true&"
import script from "./DialogStudentRating.vue?vue&type=script&lang=js&"
export * from "./DialogStudentRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d3f4be",
  null
  
)

export default component.exports